import Community from './community';
import Pages from './pages';
import PagesManagers from './pages-managers';
import PageEditorActions from './page-editor-actions';
import SynchronizedPageRegions from './synchronized-page-regions';
import Users from './users';
import Analytics from './analytics';
import Helpdesk from './helpdesk';
import DivisionIdentities from './division-identities';
import CookieModules from './cookie-modules';
import DataCollectionViews from './data-collection-views';
import Files from './files';
import Campaigns from './campaigns';
import Templates from './templates';
import Forms from './forms';
import MarketProducts from './market-products';
import MarketOrders from './market-orders';
import PromotionCodes from './promotion-codes';
import ReferralProgram from './referral-program';
import Phone from './phone';
import Finance from './finance';
import SocialNetworkOperators from './social-network-operators';
import CalendarActivities from './calendar-activities';
import PublicCalendarActivities from './public-calendar-activities';
import Proxies from './proxies';
import DataCollections from './data-collections';
import Metrics from './metrics';
import Venturz from './venturz';
import EmailTemplates from './email-templates';
import StockImages from './stock-images';
import KeywordTrackers from './keyword-trackers';
import SocialAccounts from './social-accounts';
import CommunitySocialAnalytics from './community-social-analytics';
import SocialPosts from './social-posts';
import SignaturePanel from './signature-panels';
import Assistants from './assistants';
import BlockedInboundEmailAddresses from './blocked-inbound-email-addresses';
import BlockedDisposableEmailDomains from './blocked-disposable-email-domains';
import SuppressedEmailAddresses from './suppressed-email-addresses';
import SentMessageBookmarks from './sent-message-bookmarks';
import HelpResources from './help-resources';
import RecentSearchResults from './recent-search-results';
import AlwaysOnAI from './always-on-ai';
import LLMUsage from './llm-usage';
import UserSocialAccounts from './user-social-accounts';
import Mentions from './mentions';
import ContactsDiscovery from './contacts-discovery';
import ContactsEnrichment from './contacts-enrichment';
import SearchVisibility from './search-visibility';
import PublisherDiscovery from './publisher-discovery';
import StartupDirectories from './startup-directories';
import BacklinkAcquisition from './backlink-acquisition';
import WebsitePlan from './website-plan';

class StartupInterface {

  constructor(apiClient) {

    this.userId = null;
    this.startupId = null;
    this.communityId = null;
    this.basePath = null;
    this.baseStartupUserPath = null;

    this.apiClient = null;
    this.community = null;
    this.pages = null;
    this.pagesManagers = null;
    this.users = null;
    this.analytics = null;
    this.helpdesk = null;
    this.divisionIdentities = null;
    this.campaigns = null;
    this.forms = null;
    this.marketProducts = null;
    this.marketOrders = null;
    this.referralProgram = null;
    this.phone = null;
    this.finance = null;
    this.proxies = null;
    this.keywordTrackers = null;
    this.socialAccounts = null;
    this.socialPosts = null;
    this.signaturePanel = null;
    this.blockedInboundEmailAddresses = null;
    this.blockedDisposableEmailDomains = null;
    this.suppressedEmailAddresses = null;
    this.sentMessageBookmarks = null;
    this.helpResources = null;
    this.recentSearchResults = null;
    this.alwaysOnAI = null;
    this.llmUsage = null;
    this.mentions = null;
    this.contactsDiscovery = null;
    this.contactsEnrichment = null;
    this.searchVisibility = null;
    this.publisherDiscovery = null;
    this.startupDirectories = null;
    this.backlinkAcquisition = null;
    this.websitePlan = null;

    this.apiClient = apiClient;

  }

  setBaseParameters(userId, startupId, communityId) {

    this.userId = userId;
    this.startupId = startupId;
    this.communityId = communityId;

    this.basePath = `/startups/${this.startupId}`;
    this.baseStartupUserPath = `${this.basePath}/users/${this.userId}`;

    let communityBasePath = this.basePath;

    if (this.userId !== '') {
      communityBasePath = this.baseStartupUserPath;
    }

    this.community = new Community(communityBasePath, this.communityId, this.apiClient);
    this.pages = new Pages(this.basePath, this.baseStartupUserPath, this.apiClient);
    this.pagesManagers = new PagesManagers(this.baseStartupUserPath, this.apiClient);
    this.pageEditorActions = new PageEditorActions(this.baseStartupUserPath, this.apiClient);
    this.synchronizedPageRegions = new SynchronizedPageRegions(this.baseStartupUserPath, this.apiClient);
    this.users = new Users(this.basePath, this.baseStartupUserPath, this.apiClient);
    this.analytics = new Analytics(this.baseStartupUserPath, this.apiClient);
    this.helpdesk = new Helpdesk(this.baseStartupUserPath, this.apiClient);
    this.files = new Files(this.baseStartupUserPath, this.apiClient);
    this.divisionIdentities = new DivisionIdentities(this.basePath, this.apiClient);
    this.cookieModules = new CookieModules(this.basePath, this.apiClient);
    this.dataCollectionViews = new DataCollectionViews(this.basePath, this.apiClient);
    this.campaigns = new Campaigns(this.baseStartupUserPath, this.apiClient);
    this.templates = new Templates(this.basePath, this.apiClient);
    this.forms = new Forms(this.baseStartupUserPath, this.apiClient);
    this.marketProducts = new MarketProducts(this.basePath, this.baseStartupUserPath, this.apiClient);
    this.marketOrders = new MarketOrders(this.baseStartupUserPath, this.apiClient);
    this.promotionCodes = new PromotionCodes(this.baseStartupUserPath, this.apiClient);
    this.referralProgram = new ReferralProgram(this.basePath, this.apiClient);
    this.phone = new Phone(this.basePath, this.apiClient);
    this.finance = new Finance(this.baseStartupUserPath, this.apiClient);
    this.socialNetworkOperators = new SocialNetworkOperators(this.basePath, this.apiClient);
    this.calendarActivities = new CalendarActivities(this.baseStartupUserPath, this.apiClient);
    this.publicCalendarActivities = new PublicCalendarActivities(this.basePath, this.apiClient);
    this.proxies = new Proxies(this.basePath, this.apiClient);
    this.dataCollections = new DataCollections(this.baseStartupUserPath, this.apiClient);
    this.metrics = new Metrics(this.basePath, this.baseStartupUserPath, this.apiClient);
    this.venturz = new Venturz(this.basePath, this.apiClient);
    this.emailTemplates = new EmailTemplates(this.basePath, this.apiClient);
    this.stockImages = new StockImages(this.baseStartupUserPath, this.apiClient);
    this.keywordTrackers = new KeywordTrackers(this.basePath, this.apiClient);
    this.socialAccounts = new SocialAccounts(this.basePath, this.apiClient);
    this.communitySocialAnalytics = new CommunitySocialAnalytics(this.basePath, this.apiClient);
    this.socialPosts = new SocialPosts(this.basePath, this.apiClient);
    this.signaturePanel = new SignaturePanel(this.basePath, this.apiClient);
    this.assistants = new Assistants(this.baseStartupUserPath, this.apiClient);
    this.blockedInboundEmailAddresses = new BlockedInboundEmailAddresses(this.basePath, this.apiClient);
    this.blockedDisposableEmailDomains = new BlockedDisposableEmailDomains(this.basePath, this.apiClient);
    this.suppressedEmailAddresses = new SuppressedEmailAddresses(this.basePath, this.apiClient);
    this.sentMessageBookmarks = new SentMessageBookmarks(this.baseStartupUserPath, this.apiClient);
    this.helpResources = new HelpResources(this.basePath, this.apiClient);
    this.recentSearchResults = new RecentSearchResults(this.baseStartupUserPath, this.apiClient);
    this.alwaysOnAI = new AlwaysOnAI(this.baseStartupUserPath, this.apiClient);
    this.llmUsage = new LLMUsage(this.baseStartupUserPath, this.apiClient);
    this.userSocialAccounts = new UserSocialAccounts(this.baseStartupUserPath, this.apiClient);
    this.mentions = new Mentions(this.baseStartupUserPath, this.apiClient);
    this.contactsDiscovery = new ContactsDiscovery(this.basePath, this.apiClient);
    this.contactsEnrichment = new ContactsEnrichment(this.basePath, this.apiClient);
    this.searchVisibility = new SearchVisibility(this.basePath, this.apiClient);
    this.publisherDiscovery = new PublisherDiscovery(this.basePath, this.apiClient);
    this.startupDirectories = new StartupDirectories(this.basePath, this.apiClient);
    this.backlinkAcquisition = new BacklinkAcquisition(this.basePath, this.apiClient);
    this.websitePlan = new WebsitePlan(this.basePath, this.apiClient);

  }

  getFullURL(path) {

    return this.apiClient.getURL(`${this.basePath}${path}`);

  }

  async getRoles() {

    const path = this.basePath + '/roles';

    return this.apiClient.get(path);

  }

  async getStartupPermissions() {

    const path = this.basePath + '/permissions';

    return this.apiClient.get(path);

  }

  async getCountrySpec() {

    const path = this.basePath + '/stripe-country-spec';

    return this.apiClient.get(path);

  }

  async getUserByToken(token) {

    this.apiClient.setAuthorization(token);

    const path = this.basePath + '/users/user-by-token';

    return this.apiClient.get(path);

  }

  async getActivePopulatedStartupByHost(host) {

    const path = '/startups/:host/by-host';

    return this.apiClient.get(path, { host });

  }

  async getStartupForViewById(startupId, projection) {

    const path = '/startups/:startupId/public';

    return this.apiClient.get(path, { startupId }, { projection });

  }

  async validateSendStartupInvitationsInput(startupId, invitations) {

    const path = '/startups/:startupId/invites/validate';

    return this.apiClient.post(path, { startupId }, {}, invitations);

  }

  async sendStartupInvitations(startupId, invitations) {

    const path = '/startups/:startupId/invites';

    return this.apiClient.post(path, { startupId }, {}, invitations);

  }

  async createBulkCustomerUpload(startupId, invitations) {

    const path = '/startups/:startupId/customer-invites';

    return this.apiClient.post(path, { startupId }, {}, invitations);

  }

  async findContacts(startupId, data) {

    const path = '/startups/:startupId/find-contacts';

    return this.apiClient.post(path, { startupId }, {}, data);

  }

  async updateBasicDetailsByStartupId(startupId, basicDetails) {

    const path = '/startups/:startupId/basic-details';

    return this.apiClient.put(path, { startupId }, {}, basicDetails);

  }

  async validateUpdateBasicDetailsByStartupIdInput(startupId, basicDetails) {

    const path = '/startups/:startupId/basic-details/validate';

    return this.apiClient.put(path, { startupId }, {}, basicDetails);

  }

  async inviteTeamMembersByStartupId(startupId, invitees) {

    const path = '/startups/:startupId/member-invites';

    return this.apiClient.post(path, { startupId }, {}, invitees);

  }

  async validateInviteTeamMembersByStartupIdInput(startupId, invitees) {

    const path = '/startups/:startupId/member-invites/validate';

    return this.apiClient.post(path, { startupId }, {}, invitees);

  }

  async deleteStartupDomainById(startupId) {

    const path = '/startups/:startupId/domain';

    return this.apiClient.delete(path, { startupId }, {});

  }

  async delete(startupId) {

    const path = '/startups/:startupId';

    return this.apiClient.delete(path, { startupId });

  }

  async setStartupRedirectWWWToRootById(startupId, data) {

    const path = '/startups/:startupId/redirect-www-to-root';

    return this.apiClient.put(path, { startupId }, {}, data);

  }

  async updateStartupNotificationSettingById(startupId, data) {

    const path = '/startups/:startupId/notification-settings';

    return this.apiClient.put(path, { startupId }, {}, data);

  }

  async updateStartupDomainById(startupId, domain) {

    const path = '/startups/:startupId/domain';

    return this.apiClient.put(path, { startupId }, {}, domain);

  }

  async validateUpdateStartupDomainByIdInput(startupId, domain) {

    const path = '/startups/:startupId/domain/validate';

    return this.apiClient.put(path, { startupId }, {}, domain);

  }

  async updateStartupThemeAndLayoutById(startupId, themeAndLayout) {

    const path = '/startups/:startupId/theme-and-layout';

    return this.apiClient.put(path, { startupId }, {}, themeAndLayout);

  }

  async validateUpdateStartupThemeAndLayoutByIdInput(startupId, themeAndLayout) {

    const path = '/startups/:startupId/theme-and-layout/validate';

    return this.apiClient.put(path, { startupId }, {}, themeAndLayout);

  }

  async uploadStartupIconFile(startupId, icon) {

    const path = '/startups/:startupId/icon-file';

    const data = new FormData();
    data.append('file', icon);

    return this.apiClient.put(path, { startupId }, {}, data, true);

  }

  async uploadImage(startupId, file) {

    const path = '/startups/:startupId/images';

    const data = new FormData();
    data.append('file', file);

    return this.apiClient.put(path, { startupId }, {}, data, true);

  }

  async updateStartupIconURLById(startupId, iconImageId) {

    const path = '/startups/:startupId/icon-url';

    const data = {
      iconImageId
    };

    return this.apiClient.put(path, { startupId }, {}, data);

  }

  async validateUpdateAuthenticationConfigurationByStartupId(startupId, authenticationConfiguration) {

    const path = '/startups/:startupId/authentication/validate';

    return this.apiClient.put(path, { startupId }, {}, authenticationConfiguration);

  }

  async updateAuthenticationConfigurationByStartupId(startupId, authenticationConfiguration) {

    const path = '/startups/:startupId/authentication';

    return this.apiClient.put(path, { startupId }, {}, authenticationConfiguration);

  }

  async updateStartupLoadingFirstTimeById(startupId) {

    const path = '/startups/:startupId/loading-first-time';

    return this.apiClient.put(path, { startupId }, {}, {});

  }

  async updateDisplayLiveChatOnLoadById(startupId, data) {

    const path = '/startups/:startupId/display-live-chat-on-load';

    return this.apiClient.put(path, { startupId }, {}, data);

  }

  async getAllWebhooks(startupId) {

    const path = '/startups/:startupId/webhooks';

    return this.apiClient.get(path, { startupId }, {});

  }

  async createWebhook(startupId, webhook) {

    const path = '/startups/:startupId/webhooks';

    return this.apiClient.post(path, { startupId }, {}, webhook);

  }

  async deleteWebhookById(startupId, webhookId) {

    const path = '/startups/:startupId/webhooks/:webhookId';

    return this.apiClient.delete(path, {
      startupId,
      webhookId
    }, {});

  }

  async getAPIAccessKeysByStartupId(startupId) {

    const path = '/startups/:startupId/api-access-keys';

    return this.apiClient.get(path, { startupId }, {});

  }

  async createAPIAccessKeyByStartupId(startupId) {

    const path = '/startups/:startupId/api-access-keys';

    return this.apiClient.post(path, { startupId }, {}, {});

  }

  async revokeAPIAccessKeyByStartupIdAndAPIAccessKeyId(startupId, apiAccessKeyId) {

    const path = '/startups/:startupId/api-access-keys/:apiAccessKeyId/revoke';

    return this.apiClient.put(path, { startupId, apiAccessKeyId }, {}, {});

  }

  async updateNotificationSettingsById(data) {

    const path = this.basePath + '/notification-settings';

    return this.apiClient.put(path, {}, {}, data);

  }

  async getAllStartupMembers(projection) {

    const path = `${this.basePath}/members`;

    return this.apiClient.get(path, {}, { projection });

  }

  async getStartupMemberById(memberId) {

    const path = `${this.basePath}/members/:memberId`;

    return this.apiClient.get(path, { memberId }, {}, {});

  }

  async getStartupUserBasicProfileByHumanFriendlyId(humanFriendlyId) {

    const path = `${this.basePath}/members/:humanFriendlyId/human-friendly`;

    return this.apiClient.get(path, { humanFriendlyId }, {}, {});

  }

  async getStartupUserPublicActivities(memberId, paginationOptions) {

    const path = `${this.basePath}/members/:memberId/activities`;

    return this.apiClient.get(path, { memberId }, { paginationOptions });

  }

  async updateStartupMemberEmailIdentity(memberId, emailIdentity) {

    const path = `${this.basePath}/members/:memberId/email-identity`;

    return this.apiClient.put(path, { memberId }, {}, emailIdentity);

  }

  async removeStartupMember(memberId) {

    const path = `${this.basePath}/members/:memberId`;

    return this.apiClient.delete(path, { memberId }, {}, {});

  }

  async updateStartupEmailAddressesSettingsById(startupId, addresses) {

    const path = '/startups/:startupId/email-addresses';

    return this.apiClient.put(path, { startupId }, {}, addresses);

  }

  async registerStartupEmailsDomain(startupId, domainEmailSettings) {

    const path = '/startups/:startupId/email-domain';

    return this.apiClient.put(path, { startupId }, {}, domainEmailSettings);

  }

  async verifyStartupEmailDomainDKIMRecordsById(startupId) {

    const path = '/startups/:startupId/email-domain/verify';

    return this.apiClient.put(path, { startupId }, {}, {});

  }

  async deleteVerifiedStartupEmailDomainById(startupId) {

    const path = '/startups/:startupId/email-domain';

    return this.apiClient.delete(path, { startupId }, {});

  }

  async updateStartupApplicationChatSettingsById(applicationChatSettings) {

    const path = `${this.basePath}/application-chat-settings`;

    return this.apiClient.put(path, {}, {}, applicationChatSettings);

  }

  async updateEmailAutoReplySettings(data) {

    const path = `${this.basePath}/email-auto-reply-settings`;

    return this.apiClient.put(path, {}, {}, data);

  }

  async updateStartupGDPREnabledById(data) {

    const path = `${this.basePath}/gdpr`;

    return this.apiClient.put(path, {}, {}, data);

  }

  async updateLiveChatAutoReplySettings(data) {

    const path = `${this.basePath}/live-chat-auto-reply-settings`;

    return this.apiClient.put(path, {}, {}, data);

  }

  async updateCommentsAutoReplySettings(data) {

    const path = `${this.basePath}/comments-auto-reply-settings`;

    return this.apiClient.put(path, {}, {}, data);

  }

  async updateRepliesAutoReplySettings(data) {

    const path = `${this.basePath}/replies-auto-reply-settings`;

    return this.apiClient.put(path, {}, {}, data);

  }

  async getBlockedCountriesByQueryOptions(paginationOptions) {

    const path = `${this.basePath}/blocked-countries`;

    return this.apiClient.get(path, {}, { paginationOptions });

  }

  async blockCountries(blockedCountryCodes) {

    const path = `${this.basePath}/blocked-countries`;

    return this.apiClient.put(path, {}, {}, blockedCountryCodes);

  }

  async unblockCountry(countryCode) {

    const path = `${this.basePath}/blocked-countries/:countryCode`;

    return this.apiClient.delete(path, { countryCode }, {});

  }

  async getBlockedIPAddressesByQueryOptions(paginationOptions) {

    const path = `${this.basePath}/blocked-ip-addresses`;

    return this.apiClient.get(path, {}, { paginationOptions });

  }

  async blockIPAddresses(blockedIPAddresses) {

    const path = `${this.basePath}/blocked-ip-addresses`;

    return this.apiClient.put(path, {}, {}, blockedIPAddresses);

  }

  async unblockIPAddress(ipAddress) {

    const path = `${this.basePath}/blocked-ip-addresses/:ipAddress`;

    return this.apiClient.delete(path, { ipAddress }, {});

  }

  async getBlockedCitiesByQueryOptions(paginationOptions) {

    const path = `${this.basePath}/blocked-cities`;

    return this.apiClient.get(path, {}, { paginationOptions });

  }

  async blockCities(cities) {

    const path = `${this.basePath}/blocked-cities`;

    return this.apiClient.put(path, {}, {}, cities);

  }

  async unblockCity(countryCode, city) {

    const path = `${this.basePath}/blocked-cities/:countryCode/:city`;

    return this.apiClient.delete(path, { countryCode, city }, {});

  }

  async setAccessLevelToMember(startupUserId) {

    const path = `${this.basePath}/users/:userId/ensure-member-access-level`;

    return this.apiClient.post(path, { userId: startupUserId }, {}, {});

  }

  async setAccessLevelToAdministrator(startupUserId) {

    const path = `${this.basePath}/users/:userId/ensure-administrator-access-level`;

    return this.apiClient.post(path, { userId: startupUserId }, {}, {});

  }

  async createAccountSession() {

    const path = `${this.basePath}/stripe/account-session`;

    return this.apiClient.post(path, {}, {}, {});

  }

  async bootstrapBrowserClient() {

    const path = `${this.basePath}/browser-client`;

    return this.apiClient.get(path, {}, {});

  }

  async getStartupPlan(startupId) {

    const path = '/startups/:startupId/startup-plan';

    return this.apiClient.get(path, { startupId }, {});

  }

  async sendStartupPlanItemAsMessage(startupId, itemId) {

    const path = '/startups/:startupId/startup-plan/items/:itemId/as-message';

    return this.apiClient.post(path, { startupId, itemId }, {}, {});

  }

  async archiveStartupPlanItem(startupId, itemId) {

    const path = '/startups/:startupId/startup-plan/items/:itemId/archive';

    return this.apiClient.put(path, { startupId, itemId }, {}, {});

  }

  async refreshStartupPlan(startupId) {

    const path = '/startups/:startupId/startup-plan/refresh';

    return this.apiClient.post(path, { startupId }, {}, {});

  }

}

export default StartupInterface;